import { gql } from '@apollo/client'

const VIDEO_REVIEW_FIELDS = gql`
  fragment VideoReviewFields on VideoReviewType {
    id
    createdAt
    updatedAt
    deletedAt
    version
    video
    thumbnail
    avatar
    fullName
    description
    order
    isLive
    videoProcessingStatus
    videoProcessingError
  }
`

export const FIND_ONE_VIDEO_REVIEW_SECTION = gql`
  ${VIDEO_REVIEW_FIELDS}
  query findOneVideoReviewSection($platformId: String!) {
    findOneVideoReviewSection(platformId: $platformId) {
      id
      title
      description
      videoReviews {
        ...VideoReviewFields
      }
    }
  }
`

export const UPDATE_VIDEO_REVIEW_SECTION = gql`
  mutation updateVideoReviewSection($updateVideoReviewSectionInputFieldName: UpdateVideoReviewSectionInput!) {
    updateVideoReviewSection(updateVideoReviewSectionInputFieldName: $updateVideoReviewSectionInputFieldName) {
      id
      title
      description
    }
  }
`

export const FIND_ONE_VIDEO_REVIEW = gql`
  ${VIDEO_REVIEW_FIELDS}
  query findOneVideoReview($id: String!) {
    findOneVideoReview(id: $id) {
      ...VideoReviewFields
    }
  }
`

export const CREATE_VIDEO_REVIEW = gql`
  ${VIDEO_REVIEW_FIELDS}
  mutation createVideoReview($createVideoReviewInput: CreateVideoReviewInput!) {
    createVideoReview(createVideoReviewInput: $createVideoReviewInput) {
      ...VideoReviewFields
    }
  }
`

export const UPDATE_VIDEO_REVIEW = gql`
  ${VIDEO_REVIEW_FIELDS}
  mutation updateVideoReview($updateVideoReviewInputFieldName: UpdateVideoReviewInput!) {
    updateVideoReview(updateVideoReviewInputFieldName: $updateVideoReviewInputFieldName) {
      ...VideoReviewFields
    }
  }
`

export const BULK_UPDATE_VIDEO_REVIEW = gql`
  mutation bulkUpdateVideoReview($bulkUpdateVideoReviewInput: [BulkUpdateVideoReviewInput!]!) {
    bulkUpdateVideoReview(bulkUpdateVideoReviewInput: $bulkUpdateVideoReviewInput) {
      id
    }
  }
`

export const REMOVE_VIDEO_REVIEW = gql`
  mutation removeVideoReview($id: String!) {
    removeVideoReview(id: $id) {
      affected
    }
  }
`
